//DB
import { LOCAL_STORAGE_KEYS, USER_STATUS } from '../../constants/AppConstants';
import { PBStorage } from '../../services/storageService/GlobalData';

class FeedLotUsersManager {
  //save FeedLotUsers
  async saveUsers(UsersToSave) {
    try {
      let savedUsers = (await PBStorage.get(LOCAL_STORAGE_KEYS.USERS)) || [];
      for (let i = 0; i < UsersToSave.length; i++) {
        let savedUserIndex = savedUsers.findIndex(
          (q) => q.user_id == UsersToSave[i].user_id,
        );
        if (savedUserIndex != -1) {
          savedUsers[savedUserIndex] = UsersToSave[i];
        } else {
          savedUsers.push(UsersToSave[i]);
        }
      }
      await PBStorage.set(LOCAL_STORAGE_KEYS.USERS, savedUsers);
      return true;
    } catch (e) {
      console.log('saveUsersfailed', e);
      return false;
    }
  }

  async saveUserInfo(user) {
    try {
      await PBStorage.set(LOCAL_STORAGE_KEYS.USER, user);
      return true;
    } catch (err) {
      console.log(err);
    }
  }

  async saveUser(user) {
    try {
      let users = (await PBStorage.get(LOCAL_STORAGE_KEYS.USERS)) || [];
      let userIndex = users.findIndex((q) => q.user_id == user.id);
      if (userIndex != -1) {
        users[userIndex] = user;
      } else {
        users.push(user);
      }

      let savedUsers = (await PBStorage.get(LOCAL_STORAGE_KEYS.USERS)) || [];
      for (let i = 0; i < users.length; i++) {
        let savedUserIndex = savedUsers.findIndex(
          (q) => q.user_id == users[i].user_id,
        );
        if (savedUserIndex != -1) {
          savedUsers[savedUserIndex] = users[i];
        } else {
          savedUsers.push(users[i]);
        }
      }
      await PBStorage.set(LOCAL_STORAGE_KEYS.USERS, savedUsers);

      return true;
    } catch (err) {
      console.log(err);
    }
  }

  async getUserById(id) {
    let users = (await PBStorage.get(LOCAL_STORAGE_KEYS.USERS)) || [];

    users = users.find((q) => q.user_id == id);
    return users;
  }

  async getActiveUsers() {
    let users = (await PBStorage.get(LOCAL_STORAGE_KEYS.USERS)) || [];

    users = users.filter((q) => q.status == 1).filter((q) => q.profile != null);

    users = users.sort((a, b) =>
      a.profile.first_name.localeCompare(b.profile.first_name),
    );

    return users || [];
  }

  async searchUsers(status, searchValue) {
    try {
      let users = (await PBStorage.get(LOCAL_STORAGE_KEYS.USERS)) || [];

      if (status != USER_STATUS.LOCKED) {
        users = users.filter((q) => q.status == status);
      } else {
        users = users.filter((q) => q.is_locked == 1);
      }

      if (users.length > 0) {
        if (searchValue && searchValue != '') {
          users = users.filter((item) => {
            return (
              item.user_name
                .toLowerCase()
                .includes(searchValue.toLowerCase()) ||
              (item.profile.first_name + ' ' + item.profile.last_name)
                .toLowerCase()
                .includes(searchValue.toLowerCase())
            );
          });
        }

        return users || [];
      } else {
        return [];
      }
    } catch (e) {
      return [];
    }
  }
}

export default new FeedLotUsersManager();
